import './index.scss'
import { TextInput, FluidForm, TextArea } from 'carbon-components-react'
TextInput.FluidForm = FluidForm
TextInput.TextArea = TextArea
export { TextInput, FluidForm, TextArea, TextInput as default }
